import React, { useState } from 'react'
import styled, { useTheme } from 'styled-components'
import { Text, TextVariant } from '../../Text'
import TableArrow, { ArrowDirection } from './TableArrow'

const PageButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
`

interface IPaginationButtonsProps {
  onPageChanged: (pageNumber: number) => void
  maxPage: number
  initialPage?: number
}

const PaginationButtons: React.FunctionComponent<IPaginationButtonsProps> = (props) => {
  const { onPageChanged, initialPage, maxPage } = props
  const theme = useTheme()
  const [page, setPage] = useState(initialPage || 1)
  return (
    <PageButtons>
      <TableArrow
        onClick={() => {
          const changedPage = page - 1
          onPageChanged(changedPage)
          setPage(changedPage)
        }}
        disabled={page === 1}
        direction={ArrowDirection.LEFT}
        mr="26px"
      />
      <Text variant={TextVariant.BODY_DEFAULT_BOLD} color={theme.colors.purple}>{`Page ${page} of ${maxPage}`}</Text>
      <TableArrow
        onClick={() => {
          const changedPage = page === maxPage ? page : page + 1
          onPageChanged(changedPage)
          setPage(changedPage)
        }}
        disabled={page === maxPage}
        direction={ArrowDirection.RIGHT}
        ml="26px"
      />
    </PageButtons>
  )
}

export default PaginationButtons
